@if (!item.hidden && (isGrantedRole && (!item.isCoordenador || (item.isCoordenador && isCoordenador)))) {
  <!-- normal collapsable -->
  @if (!item.url && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.url -->
  @if (item.url && !item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}"
      [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl -->
  @if (item.url && item.externalUrl && !item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event)"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.function -->
  @if (!item.url && item.function) {
    <span class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </span>
  }
  <!-- item.url && item.function -->
  @if (item.url && !item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      [routerLink]="[item.url]" [routerLinkActive]="['active', 'bg-primary', 'text-on-primary']"
      [routerLinkActiveOptions]="{exact: item.exactMatch || false}">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <!-- item.externalUrl && item.function -->
  @if (item.url && item.externalUrl && item.function) {
    <a class="nav-link" [ngClass]="item.classes"
      (click)="toggleOpen($event);item.function()"
      [href]="item.url" [target]="item.openInNewTab ? '_blank' : '_self'">
      <ng-container *ngTemplateOutlet="itemContent"></ng-container>
    </a>
  }
  <ng-template #itemContent>
    @if (item.icon) {
      <mat-icon class="nav-link-icon">{{item.icon}}</mat-icon>
    }
    <span class="nav-link-title" [translate]="item.translate">{{item.title}}</span>
    @if (item.badge) {
      <span class="nav-link-badge" [translate]="item.badge.translate"
        [ngStyle]="{'background-color': item.badge.bg,'color': item.badge.fg}">
        {{item.badge.title}}
      </span>
    }
    @if (item.badgeCompartilhada) {
      <span class="nav-link-badge-shares" matTooltip="Compartilhadas"
        [ngStyle]="{'background-color': item.badgeCompartilhada.badge.bg,'color': item.badgeCompartilhada.badge.fg}">
        {{item.badgeCompartilhada.badge.title}}
      </span>
    }
    <mat-icon class="collapsable-arrow">keyboard_arrow_right</mat-icon>
  </ng-template>
  <div class="children" [@slideInOut]="isOpen">
    <!-- ALTERADO PELA PGE-RS: não esconder os itens. -->
    @for (child of item.children; track child.id) {
      @if (child.type==='item') {
        <cdk-nav-vertical-item [item]="child" [hidden]="child.id==='outros-generos'"></cdk-nav-vertical-item>
      }
      @if (child.type==='collapsable' && item.allowGroupOfHiddenChildren) {
        <cdk-nav-vertical-collapsable
          [item]="child"
          [hidden]="child.id==='outros-generos'"
        [allowGroupOfHiddenChildren]="child.allowGroupOfHiddenChildren"></cdk-nav-vertical-collapsable>
      }
      @if (child.type==='group') {
        <cdk-nav-vertical-group [item]="child" [hidden]="child.id==='outros-generos'"></cdk-nav-vertical-group>
      }
    }
  </div>
}
